import { useEffect } from "react";
import * as CookieConsent from "vanilla-cookieconsent";
import { useSettings } from "hooks/useStore";
import { EN_CONTENT } from "./content";
import { EUR_COUNTRIES } from "utils/constants";

const CookieConsentBanner = () => {
	const { customerCountry } = useSettings(["customerCountry"]);

	function gtag() {
		window.dataLayer = window.dataLayer ?? [];
		window.dataLayer.push(arguments);
	}

	const updateGTMConsent = (consent) => {
		const getConsentStatus = (type) => consent?.categories?.includes(type) ? "granted" : "denied";

		const consentSettings = {
			analytics_storage: getConsentStatus("analytics_storage"),
			ad_storage: getConsentStatus("ad_storage"),
			ad_personalization: getConsentStatus("ad_personalization"),
			ad_user_data: getConsentStatus("ad_user_data"),
		};

		gtag("consent", "update", consentSettings);
		window.dataLayer.push({ event: "update_consent" });

		// Microsoft UET consent update
		window.uetq = window.uetq || [];
		window.uetq.push("consent", "update", { ad_storage: consentSettings.ad_storage });
	};

	useEffect(() => {
		if (!customerCountry) return;

		if (![...EUR_COUNTRIES, "GB"].includes(customerCountry)) {
			gtag("consent", "update", {
				analytics_storage: "granted",
				ad_storage: "granted",
				ad_personalization: "granted",
				ad_user_data: "granted",
			});
			window.dataLayer.push({ event: "update_consent" });

			window.uetq = window.uetq || [];
			window.uetq.push("consent", "default", { ad_storage: "granted" });
			return;
		}

		const storedConsent = CookieConsent.getCookie();

		if (storedConsent?.categories?.length) {
			updateGTMConsent(storedConsent);
		}

		// Initialize CookieConsent
		CookieConsent.run({
			revision: 1,
			disablePageInteraction: false,
			onFirstConsent: ({ cookie }) => {
				updateGTMConsent(cookie);
				gtag("event", "update_consent");
			},
			categories: {
				necessary: { readOnly: true },
				analytics_storage: { enabled: false },
				ad_storage: { enabled: false },
				ad_personalization: { enabled: false },
				ad_user_data: { enabled: false },
			},
			guiOptions: {
				consentModal: { layout: "bar", position: "middle center", transition: "slide" },
				preferencesModal: { layout: "box", transition: "slide" },
			},
			language: {
				default: "en",
				translations: { en: EN_CONTENT },
			},
		});
	}, [customerCountry]);

	return null;
};

export default CookieConsentBanner;
